import React from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { getBackendEventExtensionsDir } from '@wix/cli-astro-definitions';
import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
  useValidation,
} from '../../../dev-center/components/validations/index.js';
import { useWixCliAstroBi } from '../../../bi/index.js';
import { useWizardStep } from '../Wizard.js';
import { useProjectModel } from '../../../model.js';

export const ChooseFolderStep: FC<{
  eventFolder?: string;
  onSubmit: (value: string) => void;
}> = ({ onSubmit, eventFolder }) => {
  const { model } = useProjectModel();
  const bi = useWixCliAstroBi();
  const { isActive, goToNextStep } = useWizardStep();

  const validateEventFolder = useValidation(
    composeValidations([
      [
        pathValidation,
        "Event name must be unique, can't include special characters or spaces, and must be shorter than 20 characters",
      ],
      [
        pathAvailableValidation(
          getBackendEventExtensionsDir(model.projectFolder)
        ),
        "Event name must be unique, can't include special characters or spaces, and must be shorter than 20 characters",
      ],
    ])
  );

  return (
    <TextInput
      isActive={isActive}
      label={'Event folder:'}
      placeholder={eventFolder ?? 'my-event'}
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: 'Event folder:',
          questionKey: 'generate_command.event.choose_folder',
          answer: value,
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateEventFolder}
    />
  );
};
